import Util from '@utils/util';
export default {
  name: 'LazyImage',
  props: {
    src: String
  },
  data: function data() {
    return {
      loaded: false
    };
  },
  methods: {
    srcHttps: function srcHttps() {
      return Util.forceHttps(this.src);
    },
    handleImageLoaded: function handleImageLoaded() {
      this.loaded = true;
    }
  }
};